export enum REWARDS_REWARD_TYPES {
    points = "points",
    discount = "discount",
    giftCard = "gift_card",
    freeProduct = "free_product",
}

export type REWARDS_REWARD_TYPE = `${REWARDS_REWARD_TYPES}`;
